<div class="messages no-scrollbar" #messages (scroll)="onScroll()">
  @for (message of chatService.messages; track message) { @switch (message.type) { @case ('system') {
  <app-chat-system-message [type]="message.type2" [message]="message"></app-chat-system-message>
  } @case ('advertisement') {
  <app-chat-game-event [event]="message"></app-chat-game-event>
  } @case ('announcement') {
  <app-chat-big-win [event]="message"></app-chat-big-win>
  } @case ('supplyDropStart') {
  <app-chat-supply-drop [event]="message"></app-chat-supply-drop>
  } @case ('supplyDropEnd') {
  <app-chat-supply-drop [event]="message"></app-chat-supply-drop>
  } @case ('message') {
  <app-chat-user-message
    class="message"
    [message]="message"
    [toggleUserAction]="message.profile"
    [toggleUserActionMessage]="message"
    [toggleChatMessage]="message.content"
    [toggleUserLevel]="message.profile.level"
  ></app-chat-user-message>
  } @default {
  <app-chat-user-message class="message" [message]="message" [toggleUserAction]="message.profile" [toggleUserActionMessage]="message"></app-chat-user-message>
  } } }
</div>
<div class="pinned-messages">
  <app-chat-rain></app-chat-rain>
  <app-supply-drop-widget></app-supply-drop-widget>
  @for (pinnedMessage of chatService.pinnedMessages; track pinnedMessage) {
  <app-chat-system-message type="pinned" [message]="pinnedMessage"></app-chat-system-message>
  }
</div>

@if (disableScrollDown) {
<div class="scroll-down" (click)="scrollToBottom(true)" [@fadeInOut]><span>Scroll to the bottom</span></div>
}
